import * as React from "react";
import {Button} from "react-bootstrap";
import {IMAGES, KContainer, KStandardFooter, Translate} from "@kopjra/uikit";
import {navigate, Routes} from "../../utils/router.tsx";
import {useTranslation} from "react-i18next";
import {Toolbar} from "../Toolbar.tsx";

export const KopjraLandingPage: React.FC = () => {

    const {t} = useTranslation();

    return (
        <div>
            <Toolbar/>
            <KContainer fluid={true} className="landing text-center">
                <img src={IMAGES["web-forensics"].still.large.default} height={180} alt={"Web Forensics"} style={{marginTop: 70}}/>
                <span className={"appName"}>Web Forensics</span>
                <h4 style={{paddingTop: 20}}><Translate i18nKey="home.payoff"/></h4>
                <h4 className="call" style={{paddingTop: 50}}><Translate i18nKey="home.call"/></h4>
                <div style={{paddingTop: 50}}>
                    <Button
                        variant={"primary"}
                        onClick={() => Routes.goSessions()}
                    >
                        <i className="fal fa-sign-in-alt"/> <Translate i18nKey="bar.login"/>
                    </Button>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <Button
                        variant={"primary"}
                        onClick={() => navigate("https://store.kopjra.com")}
                    >
                        <i className="fal fa-shopping-cart"/> <Translate i18nKey="bar.buy"/>
                    </Button>
                </div>
                <h4 style={{paddingTop: 35}}><a className="link" href={`mailto:info@kopjra.com?subject=${t("home.contactSubject")}&body=${t("home.contactBody")}`} target="_blank" rel="noopener noreferrer"><Translate i18nKey="home.contactus"/></a></h4>
            </KContainer>
            <KStandardFooter/>
            <div className={"text-center"} style={{backgroundColor: "#363d49"}}>
                <Button variant="link" onClick={() => Routes.goLogin()} style={{color: "#FFFFFF", fontSize: 12, textTransform: "none"}}><Translate i18nKey="bar.loginInternal"/></Button>
            </div>
        </div>
    );
};